import { CustomerId } from '@tivio/sdk-react'
import React, { createContext, PropsWithChildren } from 'react'


export const CustomerContext = createContext<CustomerId | null>(null)

/**
 * Defines which tivio and app configs will be used for app build
 */
export const CustomerProvider: React.FC<{ customer: CustomerId } & PropsWithChildren> = (props) => {
    const { customer } = props

    return (
        <CustomerContext.Provider value={customer}>
            {props.children}
        </CustomerContext.Provider>
    )
}
